<template lang="pug">
  .page
    section.head
      .bg.h-100.w-100
      b-container
        .row
          .col-md-4
            h1.text-white CORPORATE ART
            p.ml-3.text-white
              | At Wall we recognize the unique needs of corporates when it comes to investing in art.
              | No business is the same, and we believe this introduces the need for carefully curated spaces.
              | To ensure that clients experience the ethos of your business when visiting your space,
              | we provide a custom offering to suit your needs.
    section
      b-container.text-left.p-md-5
        p
          | Our corporate rental service includes a personal site visit and consultation,
          | a bespoke presentation and proposal including curated recommendations,
          | as well as taking care of installation.
        p
          | While all art on our platform is available for purchase,
          | we also provide a flexible monthly offering to ensure all corporates
          | have access to premium, original and local art.
          | Whether you’d like to test a selection of works before buying,
          | or simply prefer the variety of a rotating collection for different seasons or events,
          | we’ve got what you’re looking for.
        p
          | Get in touch with us if you would like to know more or to book a consultation.
        b-button.btn-outline(:to="{ name: 'contact'}") ENQUIRE
    section
      masonry.gallery(:cols="{default: 4, 1000: 3, 700: 2, 400: 1}")
        .piece(v-for="piece in pieces")
          img.thumbnail(:src="piece")
</template>

<script>
import standardMix from '@/mixins/standardMix';
// import { apiService } from '@/services';
// import Vue from 'vue';
// import router from '@/router';

export default {
  metaInfo() {
    return { title: 'Wall Collective corporate art rental' };
  },
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      pieces: [
        'https://ams3.digitaloceanspaces.com/wall.res/resources/images/corporate_1.jpg',
        'https://ams3.digitaloceanspaces.com/wall.res/resources/images/corporate_2.jpg',
        'https://ams3.digitaloceanspaces.com/wall.res/resources/images/corporate_3.jpg',
        'https://ams3.digitaloceanspaces.com/wall.res/resources/images/corporate_4.jpg',
        'https://ams3.digitaloceanspaces.com/wall.res/resources/images/corporate_5.jpg',
        'https://ams3.digitaloceanspaces.com/wall.res/resources/images/corporate_6.jpg',
        'https://ams3.digitaloceanspaces.com/wall.res/resources/images/corporate_7.jpg',
        'https://ams3.digitaloceanspaces.com/wall.res/resources/images/corporate_8.jpg',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.head {
  background-color: black;
  z-index: 0;
  position: relative;
  height: 80vh;
  overflow: hidden;
  .bg {
    // background-attachment: fixed;
    opacity: 0.5;
    position: absolute;
    left: 0;
    top: 0;
    background-size: cover;
    background-position: center;
    background-image: url("https://ams3.digitaloceanspaces.com/wall.res/resources/images/corporate_cover.jpg");
    // @include desktop {
    //   background-image: url("https://ams3.digitaloceanspaces.com/wall.res/resources/backgrounds/banner_1.jpg");
    // }
  }
}
  .inst-tile {
    height: 100px;
  }
  .piece {
      transition: all ease-in 0.5s;
      margin: 15px;
      opacity: 1;
      .thumbnail {
        width: 100%;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/CorporateRentals.vue